import React from 'react';
import { getMessage } from '@tcc/i18n';
import { useAppSelector } from 'app/hooks';
import { getSelectedLayers, getSelectedMapLayer, isSelectGenerateZonesSelectLayerStep } from './selectors';
import { MAX_SELECTED_LAYERS } from 'manual/constants';

const SelectedLayersTracker = () => {
  const isSelectLayersStep = useAppSelector(isSelectGenerateZonesSelectLayerStep);
  const selectedLayers = useAppSelector(getSelectedLayers);
  const selectedMapLayer = useAppSelector(getSelectedMapLayer);

  return isSelectLayersStep && selectedMapLayer.selectedMapType ? (
    <section data-test-id='selected-layers-tracker'>
      {getMessage('label-text__generate-zones-layers-maximum-select', {
        selectedLayers: selectedLayers?.length.toString() ?? '0',
        maximumLayers: MAX_SELECTED_LAYERS[selectedMapLayer.selectedMapType]
      })}
    </section>
  ) : null;
};

export default SelectedLayersTracker;
